<template>
  <div v-if="shouldShowCreditTip" class="credit-tip">
    {{
      $t(
        'tao-can-sheng-xiao-zhong-xu-yue-hou-quan-yi-jiang-yu-rightsviewgetexpiredata-sheng-xiao-ru-guo-xu-yao-zeng-gou-yan-bi-qing-dan-du-gou-mai',
        [displayedValidityRange],
      )
    }}
    <span class="alert__clickable-link" @click="handleAddCreditCoins">
      {{ $t('yan-bi-jia-gou-bao') }}
    </span>
    <template v-if="rights?.length > 0">
      <span class="alert__clickable-link-separator">{{ $t('huo') }}</span>
      <span class="alert__clickable-link" @click="handleUpgradePackage">
        {{ $t('sheng-ji-tao-can') }}
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { getOrderClientUpgradePrice } from '@rendora/common/entities/order';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store';
import { IEquity } from '@rendora/common/store/rights';
import { IRightsType } from '@rendora/common/types/enums';
import dayjs from 'dayjs';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { showBuyCreditModal } from '../../buy-credit';
import { showUpgradeEquityModal } from '../../upgrade-equity';

const i18nService = getI18nService();
const $t = i18nService.t;

// Props
const props = defineProps<{
  selectedFee?: { days?: number };
}>();

// Store 初始化
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

// 可升级权益（预留：用于展示"升级套餐"）
const rights = ref<IEquity[]>([]);

// 加载态
const pending = ref(false);

// 展示文案：续约生效区间（beginDate ~ endDate）
const displayedValidityRange = computed(() => {
  let endDate = dayjs()
    .add(props.selectedFee?.days || 0, 'day')
    .format('YYYY.MM.DD');

  let beginDate = dayjs().format('YYYY.MM.DD');

  if (user.value?.personal_expired_time) {
    beginDate = dayjs(user.value.personal_expired_time).format('YYYY.MM.DD');
    endDate = dayjs(user.value.personal_expired_time)
      .add(props.selectedFee?.days || 0, 'day')
      .format('YYYY.MM.DD');
  }
  return `${beginDate}~${endDate}`;
});

function handleAddCreditCoins() {
  showBuyCreditModal();
}

function handleUpgradePackage() {
  showUpgradeEquityModal();
}

// 是否显示续约提示（当用户已有个人/轻享权益时）
const shouldShowCreditTip = computed(() => {
  if (!user.value) return false;
  return [IRightsType.PERSONAL, IRightsType.PERSONAL_LITE].includes(user.value?.rights_type);
});

onMounted(async () => {
  // 拉取可升级价格/权益
  pending.value = true;
  try {
    const res = await getOrderClientUpgradePrice();
    if (res.data) {
      rights.value = res.data;
    }
  } catch (err) {
    console.error(err);
  }
  pending.value = false;
});
</script>

<style lang="scss" scoped>
.alert__clickable-link {
  color: var(--x-warning-9);
  cursor: pointer;
  &:hover {
    color: var(--x-warning-8);
  }
}

.alert__clickable-link-separator {
  padding-inline: 4px;
}

.credit-tip {
  margin-top: 20px;
  color: var(--x-text-3);
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
}
</style>
